import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useDirectorSessionsForMonth } from '@/hooks/use-director-data';
import { SessionCalendar } from '@/components/shared/session-calendar';
import { SessionFormModal } from '@/components/coach/session-form-modal';

export default function DirectorCalendarPage() {
  const navigate = useNavigate();
  const [calendarMonth, setCalendarMonth] = useState(() => new Date());
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [defaultDate, setDefaultDate] = useState(() => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  });

  const { data: monthData } = useDirectorSessionsForMonth(
    calendarMonth.getFullYear(),
    calendarMonth.getMonth()
  );

  const handleSessionClick = () => {
    navigate('/director/sessions');
  };

  const handleMonthChange = (year: number, month: number) => {
    setCalendarMonth(new Date(year, month, 1));
    setDefaultDate(`${year}-${String(month + 1).padStart(2, '0')}-01`);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-foreground">Calendar</h1>
        <Button size="sm" className="flex items-center gap-2" onClick={() => setShowCreateModal(true)}>
          <Plus className="w-4 h-4" />
          Add Session
        </Button>
      </div>

      <SessionCalendar
        sessions={monthData?.sessions ?? []}
        isLoading={!monthData}
        onSessionClick={handleSessionClick}
        onMonthChange={handleMonthChange}
        variant="director"
      />

      <SessionFormModal
        open={showCreateModal}
        onOpenChange={setShowCreateModal}
        defaultDate={defaultDate}
      />
    </div>
  );
}
